var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_13fdc916"]},_vm.$listeners),[_c('cube-button',{attrs:{"disabled":""}},[_vm._v("置灰态")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }